export default {"src":"/_next/static/media/social.176ace66.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};